// 个人中心
export const PATH_PERSONAL = '/personal'
